function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { KYBProgressStatusEnum, KYBProgressStatusHelpers } from 'anchor-kyb-service/types';
import { Typography, Button } from 'seagull';
import VerifyYourIdentity from "./steps/VerifyYourIdentity/VerifyYourIdentity";
import { selectors } from "../../../store/state-selectors";
import styles from "./BusinessOnboardingWidget.module.scss";
import CompleteKYC from "./steps/CompleteKYC/CompleteKYC";
import ConnectBankAccount from "./steps/ConnectBankAccount/ConnectBankAccount";
import SetUpBrand from "./steps/SetUpBrand/SetUpBrand";
import SetupServices from "./steps/SetupServices";
import TestAgreement from "./steps/TestAgreement/TestAgreement";
import TutorialVideos from "./steps/TutorialVideos/TutorialVideos";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepTitle = _ref => {
  let {
    children,
    spacing = 'normal'
  } = _ref;
  return /*#__PURE__*/_jsx(Typography, {
    className: styles[spacing + 'Spacing'],
    weight: "normal",
    variant: "h6",
    children: children
  });
};
export const StepSubtitle = _ref2 => {
  let {
    children,
    spacing = 'normal'
  } = _ref2;
  return /*#__PURE__*/_jsx(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph1",
    children: children
  });
};
export const StepHelperText = _ref3 => {
  let {
    children,
    spacing = 'normal',
    dataTestId
  } = _ref3;
  return /*#__PURE__*/_jsx(Typography, {
    className: styles[spacing + 'Spacing'],
    variant: "paragraph2",
    skin: "secondary",
    "data-testid": dataTestId,
    children: children
  });
};
export const ActionButton = props => {
  return /*#__PURE__*/_jsx(Button, _objectSpread({
    size: "medium"
  }, props));
};
export function StepLayout(props) {
  const {
    id,
    title,
    subtitle,
    actions,
    icon
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.stepLayout,
    "data-testid": "onboarding-widget-content-".concat(id),
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(StepTitle, {
          children: title
        }), /*#__PURE__*/_jsx(StepSubtitle, {
          children: subtitle
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.actions,
        children: actions
      })]
    }), /*#__PURE__*/_jsx("div", {
      children: icon
    })]
  });
}
export const getStepsInfo = _ref4 => {
  var _numSampleAgreements$, _numSampleAgreements$2;
  let {
    videos,
    userInfo,
    isMemberUser,
    hasSentAProposal,
    personaKYBStatus,
    modifiedAServiceTemplate,
    startKyc,
    removeVerifyYourIdentityStep = false
  } = _ref4;
  const {
    numSampleAgreements
  } = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.business()) || {};
  const logoUrl = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessLogoUrl();
  const totalSampleAgreements = ((_numSampleAgreements$ = numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.approved) !== null && _numSampleAgreements$ !== void 0 ? _numSampleAgreements$ : 0) + ((_numSampleAgreements$2 = numSampleAgreements === null || numSampleAgreements === void 0 ? void 0 : numSampleAgreements.pending) !== null && _numSampleAgreements$2 !== void 0 ? _numSampleAgreements$2 : 0);
  const isConnectBankAccountStepComplete = selectors.user.hasBankAccountConnected({
    userInfo: userInfo || null
  });
  const isKycStepComplete = personaKYBStatus === KYBProgressStatusEnum.Approved;
  const isVerifyYourIdentityStepCompleted = userInfo ? !userInfo.disabledPayments() : false;
  const steps = [{
    id: 'brand',
    label: 'Set up your brand',
    complete: !!logoUrl,
    minutes: 1,
    component: SetUpBrand
  }, {
    id: 'setupServices',
    label: 'Set up services',
    complete: modifiedAServiceTemplate,
    minutes: 2,
    component: SetupServices,
    hide: isMemberUser
  }, {
    id: 'testAgreement',
    label: 'Send a test agreement',
    complete: totalSampleAgreements > 0 || hasSentAProposal,
    minutes: 5,
    component: TestAgreement
  }, {
    id: 'connectBankAccount',
    label: 'Connect bank account',
    complete: isConnectBankAccountStepComplete,
    minutes: 1,
    component: ConnectBankAccount
  }, {
    id: 'kyc',
    label: 'Verify your business',
    complete: isKycStepComplete,
    minutes: 3,
    component: CompleteKYC,
    extraProps: {
      startKyc,
      isUnderReview: personaKYBStatus != null && (KYBProgressStatusHelpers.isAwaitingDecision(personaKYBStatus) || personaKYBStatus === KYBProgressStatusEnum.Errored)
    }
  }, ...(removeVerifyYourIdentityStep ? [] : [{
    id: 'verifyYourIdentity',
    label: 'Activate your account',
    complete: isVerifyYourIdentityStepCompleted,
    component: VerifyYourIdentity,
    extraProps: {
      kycStepComplete: isKycStepComplete,
      connectBankAccountStepComplete: isConnectBankAccountStepComplete
    }
  }]), {
    id: 'tutorialVideos',
    label: 'Watch tutorial videos',
    complete: Object.values(videos).filter(_ref5 => {
      let {
        watched
      } = _ref5;
      return watched;
    }).length >= 4,
    component: TutorialVideos
  }];
  return {
    steps,
    isRequiredStepsCompleted: isConnectBankAccountStepComplete && isKycStepComplete && isVerifyYourIdentityStepCompleted,
    numCompleted: steps.filter(s => s.complete).length,
    areAllStepsCompleted: steps.every(s => s.complete)
  };
};